import { Component, ViewChild, AfterViewInit } from '@angular/core';

import { ConnectionManagerService } from './services/storage/connection-manager.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SyncService } from './services/sync/sync.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { SyncDialogComponent } from './pages/synchronization/sync-dialog/sync-dialog.component';
import { NavigationEnd, Router } from '@angular/router';
import { SyncItemType, syncCategories } from './models/sync.model';
import { SyncTimerService } from './services/sync/Sync-timer.service';
import { MatSidenav } from '@angular/material/sidenav';
import { MediaSizeService } from './services/media-size.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  @ViewChild('drawer') drawer!: MatSidenav

  version = environment.version
  headerColor = environment.headerClass
  // mobileQuery: MediaQueryList
  dbActivated = false
  time = 0
  showSync = false
  url  = ''

  constructor(public sync: SyncService,
    cm: ConnectionManagerService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private timer: SyncTimerService,
    public media: MediaSizeService,
    router: Router


    ) {



    cm.getDb().then(() => {
      this.dbActivated = true
      console.log('db create hook in app component')
    }).catch((reason) => {
      let str = 'произошла ошибка'
      this.dbActivated = true
      if (reason instanceof DOMException) {
        str = reason.message
      }
      this.snack.open(str, 'ok', { duration: 5000 })
    })




    this.timer.timerObs().subscribe(x => { this.time = x })
    router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        const url = e.url.split('/')[1]
        this.url = url;
        // if (syncCategories.find(x => x.url === this.url)) {
        //   this.showSync = true
        //   return
        // }
        this.showSync = false
      }
    })

  }

  ngAfterViewInit() {
    if (!this.media.isMobile) {
      setTimeout(() => {
        this.drawer.open()
      }, 50);
    }
  }


  openSyncDialog() {
    if (this.sync.running) {
      this.dialog.open(SyncDialogComponent, { width: '99%', })
    }
    else {
      const s = syncCategories.filter(x => x.url === this.url)
      if (!s || !s.length)
        return
      const cat: SyncItemType[] = s.map(x => x.id)
      this.dialog.open(SyncDialogComponent, {
        width: '99%',
        data: {
          categories: cat,
          full: false,
        }
      });
    }
  }
}
